<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()
const searchQuery = ref('')

function handleSearch() {
  if (searchQuery.value.trim()) {
    router.push({
      path: '/search',
      query: { q: searchQuery.value }
    })
  }
}
</script>

<template>
  <header class="bg-white border-b border-gray-200 px-6 py-4">
    <div class="flex items-center justify-between">
      <!-- Breadcrumb or page title could go here -->
      <div class="flex-1">
        <form
          class="max-w-md"
          @submit.prevent="handleSearch"
        >
          <div class="relative">
            <input
              v-model="searchQuery"
              type="search"
              placeholder="Search docs, SQL, tags..."
              class="w-full px-4 py-2 pl-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
            >
            <span class="absolute left-3 top-2.5 text-gray-400">🔍</span>
          </div>
        </form>
      </div>

      <!-- Right side - could add user menu, settings, etc -->
      <div class="ml-4">
        <button class="px-4 py-2 text-sm text-gray-700 hover:text-gray-900">
          Refresh Content
        </button>
      </div>
    </div>
  </header>
</template>
